export function formatDimension(value, unit) {
  const millimetres = Number(value);
  const mmLabel = Number.isInteger(millimetres)
    ? String(millimetres)
    : String(millimetres).replace(/\.0+$/, '');

  return unit === 'in'
    ? `${(millimetres / 25.4).toFixed(2)} in`
    : `${mmLabel} mm`;
}

if (typeof window !== 'undefined' && window.customElements) {
  class DessonEyewearSpecs extends HTMLElement {
    connectedCallback() {
      this.unitToggle = this.querySelector('[data-unit-toggle]');
      this.unitToggle?.addEventListener('click', this.handleUnitToggle);
      this.setUnit('mm');
    }

    disconnectedCallback() {
      this.unitToggle?.removeEventListener('click', this.handleUnitToggle);
    }

    handleUnitToggle = () => {
      this.setUnit(this.unit === 'mm' ? 'in' : 'mm');
    };

    setUnit(unit) {
      this.unit = unit === 'in' ? 'in' : 'mm';

      this.querySelectorAll('[data-dimension-mm]').forEach((dimension) => {
        dimension.textContent = formatDimension(dimension.dataset.dimensionMm, this.unit);
      });

      if (!this.unitToggle) return;

      this.unitToggle.textContent = this.unit === 'in'
        ? this.unitToggle.dataset.showMillimeters
        : this.unitToggle.dataset.showInches;
      this.unitToggle.setAttribute('aria-pressed', String(this.unit === 'in'));
      this.unitToggle.hidden = false;
    }
  }

  if (!window.customElements.get('desson-eyewear-specs')) {
    window.customElements.define('desson-eyewear-specs', DessonEyewearSpecs);
  }
}
